import React, { useState } from "react";
import Card from "./Card";
import logo from "../TestImages/StediAppIcon5.png";
import "./CardGrid.css";
import { useNavigate } from "react-router-dom";
import { tutorials } from "../Data/TutorialData";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import { TransitionGroup, CSSTransition } from "react-transition-group";


function CardGrid() {
  const [search, setSearch] = useState("");
  const [showBasicOnly, setShowBasicOnly] = useState(true);

  const filteredTutorials = tutorials
    .filter(
      (tutorial) =>
        tutorial.title.toLowerCase().includes(search.toLowerCase()) &&
        (tutorial.basicSub === true || !showBasicOnly)
    )
    .sort((a, b) => a.title.localeCompare(b.title));

  const navigate = useNavigate();

  const handleCardClick = (card) => {
    navigate(`/howto/${slugify(card.title)}`);
  };

  function slugify(text) {
    return text.trim().toLowerCase().replace(/\s+/g, "-");
  }

  return (
    <div className="grid-content">
      <div className="toggle-and-search">
        <div className="card-search">
          <input
            type="text"
            placeholder="Search by title..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="card-search-input"
          />
        </div>
        <ToggleSwitch
          isOn={showBasicOnly}
          onToggle={(value) => setShowBasicOnly(value)}
        />
      </div>
      <div className="card-grid">
        <TransitionGroup component={null}>
            {filteredTutorials.map((tutorial, index) => (
              <CSSTransition
              key={tutorial.title}
              timeout={200}
              classNames="cardfade"
            >
            <div>
              <Card
                    key={index}
                    title={tutorial.title}
                    image={logo}
                    body={tutorial.body}
                    onClick={() => handleCardClick(tutorial)}
                />
            </div>
            </CSSTransition>
   
          ))}
        </TransitionGroup>

      </div>
    </div>
  );
}

export default CardGrid;
